import type { MailSettings, MailSettingsSavePayload } from "../../services/mailSettingsService";

export const SMTP_PORT_OPTIONS = [
  { value: 587, label: "587 (STARTTLS)" },
  { value: 465, label: "465 (SSL/TLS)" },
  { value: 25, label: "25" },
  { value: 2525, label: "2525" },
] as const;

export function normalizeRecipientDomains(values: Array<string | unknown>): string[] {
  const unique: string[] = [];
  for (const raw of values) {
    if (typeof raw !== "string") continue;
    const cleaned = raw.trim().toLowerCase().replace(/^@/, "");
    if (cleaned && !unique.includes(cleaned)) {
      unique.push(cleaned);
    }
  }
  return unique;
}

export function mapFormFromResponse(data: MailSettings): MailSettingsSavePayload {
  return {
    enabled: Boolean(data.enabled),
    provider: data.provider === "OFFICE365_GRAPH" ? "OFFICE365_GRAPH" : "CUSTOM_SMTP",
    host: data.host || "",
    port: data.port > 0 ? data.port : 587,
    username: data.username || "",
    fromAddress: data.fromAddress || "",
    startTls: data.startTls !== false,
    tenantId: data.tenantId || "",
    clientId: data.clientId || "",
    allowedRecipientDomains: data.allowedRecipientDomains || [],
  };
}

export function buildMailSettingsSavePayload(
  form: MailSettingsSavePayload,
  domains: string[],
  secrets: { password?: string; clientSecret?: string },
): MailSettingsSavePayload {
  const payload: MailSettingsSavePayload = {
    ...form,
    port: Number(form.port) > 0 ? Number(form.port) : 587,
    allowedRecipientDomains: normalizeRecipientDomains(domains),
  };
  const password = secrets.password?.trim();
  const clientSecret = secrets.clientSecret?.trim();
  if (password) payload.password = password;
  if (clientSecret) payload.clientSecret = clientSecret;
  return payload;
}
